import Phaser from "phaser";
import CardGameObject, { Card } from "./Card.js";
import { cardScale } from "../BonezGame.js";

export default class PlayerBoard extends Phaser.GameObjects.Sprite {

    constructor(scene, x, y, scale, playedCards) { //playedCards is array of max length 9. Each element is an array of max 2 card objects.
        super(scene, x, y, 'all_images2', 'player_board');
        //this.scene = scene;
        this.scale = scale;
        this.yOffset = null;
        let sideBuffer = 200 * scale; //no-go area on the sides of the board
        this.effectiveWidth = this.width*scale;
        this.effectiveHeight = this.height*scale;
        this.effectiveWidthWithBuffer = this.effectiveWidth - sideBuffer*2;
        this.playedCards = [[], [], [], [], [], [], [], [], []]; //MAX LENGTH 9. Each element is an array of max 2 card objects.
        this.updatePlayedCards(playedCards);
    }

    updatePlayedCards(playedCards) {
        this.playedCards.map((column) => { //delete the previously rendered cards
            column.map((card) => {
                card.updateBubbleTexture(null);
                card.updateResurrectBanner(null);
                card.destroy();
            })
            column.length = 0;
        })

        for (let i = 0; i < playedCards.length; i++) { //display cards in their respective columns
            for (let j = 0; j < playedCards[i].length; j++) { //display cards in their respective rows
                if (playedCards[i][j]) {
                    if (playedCards[i][j].texture === "double" ||
                        playedCards[i][j].texture === "redraw" ||
                        playedCards[i][j].texture === "resurrect" ||
                        playedCards[i][j].texture === "steal"
                    ) {
                        this.yOffset = 185;
                    } else if (playedCards[i][j].texture === "tie_breaker" || 
                        playedCards[i][j].texture === "1_or_11"
                    ) {
                        this.yOffset = 50;
                    } else {
                        this.yOffset = 50;
                    }

                    const newCard = this.scene.add.card(this.x - (this.effectiveWidthWithBuffer / 2) + (this.effectiveWidthWithBuffer / 8) * i, this.y - (this.scale) + (240 * this.scale * j) - this.yOffset*this.scale, playedCards[i][j]); //expression can be simplified, but not for readability
                        if (j !== 0) {
                            newCard.setDepth(newCard.depth + 1);
                        }
                        this.playedCards[i].push(newCard);
                    }
            }
        }
    }

    setDragOverBorder(display) {
        if (display && !this.dragOverBorder) {
            this.dragOverBorder = this.scene.add.image(this.x, this.y, 'all_images2', 'card_drop_border').setScale(this.scale*1.015);
            if (this.turnBorder) {
                this.turnBorder.setAlpha(0); //hide turnBorder when showing dragOverBorder
            }
        }
        else if (!display && this.dragOverBorder) {
            this.dragOverBorder.destroy();
            this.dragOverBorder = null;
            if (this.turnBorder) {
                this.turnBorder.setAlpha(1); //show turnBorder when not showing dragOverBorder
            }
        }
    }
    
    setStealBorder(pointerX, pointerY) {
        if (this.stealBorder) { //remove previous border
            this.stealBorder.destroy();
        }
        const i = this.determineIndex(pointerX, pointerY);
        const j = 0;

        if (i !== -1) { //add border if pointer is over a populated column
            this.stealBorder = this.scene.add.image(this.x - (this.effectiveWidthWithBuffer / 2) + (this.effectiveWidthWithBuffer / 8) * i, this.y - (140*this.scale) + 90*this.scale + (240 * this.scale * j), 'all_images2', 'steal_border')
            .setScale(cardScale)
            .setDepth(this.depth);
            return true;
        }
        else {
            return false;
        }
    }

    determineIndex(pointerX, pointerY) { //returns -1 if coordinates are not over a populated column
        if (pointerX > this.x - this.effectiveWidth / 2 && pointerX < this.x + this.effectiveWidth && pointerY > this.y - this.effectiveHeight / 2 && pointerY < this.y + this.effectiveHeight / 2) { //pointer is inside the playerBoard
            let indexSelected = 0;
            for (let i = 0; i < 8; i++) { //which index is the cursor over?
                const rightBorder = this.x - (this.effectiveWidthWithBuffer / 2) + (this.effectiveWidthWithBuffer / 8) * i + (this.effectiveWidthWithBuffer / 8) / 2;
                if (pointerX < rightBorder) {
                    break;
                }
                indexSelected++;
            }

            if (this.playedCards[indexSelected][0]) { //check if pointer is over a populated column
                return indexSelected;
            }
            else {
                return -1;
            }
        }
        else {
            return -1;
        }
    }

    setTurnBorder(isTurn) {
        if (isTurn && !this.turnBorder && !this.standBorder) {
            this.turnBorder = this.scene.add.image(this.x, this.y, 'all_images2', 'turn_border').setScale(this.scale*1.015);
        }
        else if (!isTurn && this.turnBorder) {
            this.turnBorder.destroy();
            this.turnBorder = null;
        }
    }

    setStandBorder(isStanding) {
        if (isStanding && !this.standBorder) {
            this.standBorder = this.scene.add.image(this.x, this.y, 'all_images2' , 'stand_border').setScale(this.scale*1.015);
        }
        else if (!isStanding && this.standBorder) {
            this.standBorder.destroy();
            this.standBorder = null;
        }
    }
}

// Register a function to the gameobjectfactory, allowing you to use this.add.<objectname>
Phaser.GameObjects.GameObjectFactory.register("playerBoard", function (x, y, scale, playedCards) {
    const playerBoardInst = new PlayerBoard(this.scene, x, y, scale, playedCards);

    this.displayList.add(playerBoardInst);
    this.updateList.add(playerBoardInst);

    return playerBoardInst;
})